export var LIBRARY_AGENDAS = ["MONOGRAPHS", "PERIODICALS"];
export var LIBRARY_AGENDA_STATES = ["MOVED", "LINKED"];
export var parseAgendaState = function (value) { var _a; return (_a = LIBRARY_AGENDA_STATES.find(function (state) { return state === value; })) !== null && _a !== void 0 ? _a : ""; };
export var AGENDA_STATE_LIST_ERRORS = {
    AGENDA_STATE_REQUIRES_LIBRARY: "ui-br-legaldeposits.field.error.AGENDA_STATE_REQUIRES_LIBRARY",
};
export var agendaOfType = function (type) {
    return type === "PERIODICAL" ? "PERIODICALS" : "MONOGRAPHS";
};
export var otherAgenda = function (agenda) {
    return agenda === "MONOGRAPHS" ? "PERIODICALS" : "MONOGRAPHS";
};
